import { fetchEventSource } from '@microsoft/fetch-event-source';
import { settings } from 'config';

let activeAbortController: AbortController | null = null;

const normalizeBearerToken = (token: string): string => {
  const trimmed = token.trim();
  if (trimmed.startsWith('Bearer ')) {
    return trimmed;
  }
  return `Bearer ${trimmed}`;
};

export const startChatEventStream = async ({
  advisorId,
  onMessage,
  onError,
}: {
  advisorId: string;
  onMessage: (data: string) => void;
  onError: (error: unknown) => void;
}): Promise<void> => {
  stopChatEventStream();

  const token = localStorage.getItem('x-tifin-ai-token') || '';
  if (!token) {
    onError(new Error('No authentication token found'));
    return;
  }

  const abortController = new AbortController();
  activeAbortController = abortController;

  const url = `${settings.api.baseUrl}/chat/stream/${advisorId}`;

  await fetchEventSource(url, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'x-tifin-ai-auth': normalizeBearerToken(token),
    },
    signal: abortController.signal,
    openWhenHidden: true,
    onopen: async response => {
      if (!response.ok) {
        throw new Error(`Server returned ${response.status}`);
      }
    },
    onmessage: event => {
      onMessage(event.data);
    },
    onerror: error => {
      onError(error);
      throw error;
    },
  });
};

export const stopChatEventStream = (): void => {
  if (activeAbortController) {
    activeAbortController.abort();
    activeAbortController = null;
  }
};
